import {FC} from "react";
import {css} from "@pandacss/css";

interface Props {
    value: boolean,
    onChange?: (value: boolean) => void
}

const checkboxOuterClass = css({
    width: "24px",
    height: "24px",
    border: "1px solid",
    borderColor: "neutral.500",
    borderRadius: "4px",
    display: "flex",
    background: "neutral.900",
    padding: "2px"
})

const checkboxInnerClass = css({
    background: "primary.400",
    borderRadius: "2px",
    flex: 1
})

export const Checkbox: FC<Props> = ({value, onChange}) => {
    return <div className={checkboxOuterClass} onClick={() => onChange?.(!value)}>
        { value && <div className={checkboxInnerClass} />}
    </div>
}